import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OverlayManagerService {
  private excludedRoutes: string[] = [
    '/service/dashboard',
    // Add more routes to exclude here
  ];

  constructor(private router: Router) {
    // Listen for route changes
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (this.isExcludedRoute(event.urlAfterRedirects)) {
        this.disableOverlays();
      } else {
        this.enableOverlays();
      }
    });

    // Initial check
    if (this.isCurrentRouteExcluded()) {
      this.disableOverlays();
    }
  }

  private isCurrentRouteExcluded(): boolean {
    return this.isExcludedRoute(this.router.url);
  }

  private isExcludedRoute(url: string): boolean {
    return this.excludedRoutes.some(route => url.includes(route));
  }

  private disableOverlays(): void {
    // Remove any existing block-ui-overlay elements
    const overlays = document.querySelectorAll('.block-ui-overlay');
    overlays.forEach(overlay => {
      if (overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    });

    // Add a style to prevent overlays on excluded pages
    if (!document.getElementById('overlay-disable-style')) {
      const style = document.createElement('style');
      style.id = 'overlay-disable-style';
      style.textContent = `
        .block-ui-overlay {
          display: none !important;
        }
      `;
      document.head.appendChild(style);
    }
  }

  private enableOverlays(): void {
    // Remove the style that disables overlays
    const styleElement = document.getElementById('overlay-disable-style');
    if (styleElement && styleElement.parentNode) {
      styleElement.parentNode.removeChild(styleElement);
    }
  }
}
